function Submit ($) {
  // console.log('Submit Class');
  this.type = "red";
  this.color = "red";

  MenuUtility.accrdionMenu($);
}
